// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"ff337144","20":"ff337144","190":"2f5c62a8","238":"ff337144","257":"ff337144","393":"86d2a111","444":"86d2a111","710":"ff337144","927":"ff337144"}[chunkId] + ".chunk.css";
};